<template>
   <b-container>
      <b-card no-body>
         <b-card-header header-tag="nav">
            <b-nav class="card-header-tabs" card-header tabs >
               <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
               <b-nav-item to="/cms/aimanagement/search" exact exact-active-class="active">Search</b-nav-item>
               <b-nav-item to="/cms/aimanagement/configuration" exact exact-active-class="active">Configuration</b-nav-item>
            </b-nav>
         </b-card-header>
         <b-card-body class="text-center">
            <router-view></router-view>
         </b-card-body>
      </b-card>
   </b-container>
</template>

<script>
export default {
   name: 'AiManagement'
}
</script>


<style lang="scss">
.v-select.single .selected-tag {
   position: absolute;
   padding: 5px;
}

.v-select .dropdown-toggle {
   &:after {
      display: none;
   }
}
</style>